import { useMatches } from 'react-router';

export type RouteLayout = 'page' | 'bounded' | 'workspace' | 'chromeless';

const ROUTE_LAYOUTS = new Set<string>([
  'page',
  'bounded',
  'workspace',
  'chromeless',
]);

const readLayout = (handle: unknown) => {
  if (typeof handle !== 'object' || handle === null || !('layout' in handle)) {
    return undefined;
  }
  const { layout } = handle;
  return typeof layout === 'string' && ROUTE_LAYOUTS.has(layout)
    ? (layout as RouteLayout)
    : undefined;
};

export const useRouteLayout = (): RouteLayout => {
  const matches = useMatches();
  const declared = matches.findLast(
    (match) => readLayout(match.handle) !== undefined,
  );

  const layout = readLayout(declared?.handle);
  if (!layout) {
    throw new Error('Authenticated routes must declare an AppShell layout');
  }
  return layout;
};

export const isBoundedLayout = (layout: RouteLayout) =>
  layout === 'bounded' || layout === 'workspace';
